import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

type Props = Readonly<{
    id: string;
    forceClear?: boolean;
    elementType?: keyof HTMLElementTagNameMap;
}>;

export const Portal: React.FC<Props> = ({ id, forceClear, elementType, children }) => {
    const container = useRef(document.createElement(elementType ?? 'div'));

    useEffect(() => {
        const portalElement = document.getElementById(id);
        if (!portalElement) {
            return () => {};
        }

        if (forceClear) {
            portalElement.innerHTML = '';
        }
        portalElement.appendChild(container.current);

        return () => {
            portalElement.removeChild(container.current);
        };
    }, [children]);

    return ReactDOM.createPortal(children, container.current);
};
